import React from "react";
import StatisticsLayout from "../pages/statistics/StatisticsLayout";

const Statistics = () => {
    return <StatisticsLayout />;
};

export default Statistics;
